import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TextField } from '@nutrien/cxp-components';
import React, { useState } from 'react';

import { REGEX_EMAIL } from '../../utilities/constants';

interface Props {
  updateEmail: (email: string) => void;
}

const useStyles = makeStyles({
  space: {
    margin: '0px 0px 10px 0px',
  },
});

const SignUpFlowEmail = ({ updateEmail }: Props) => {
  const classes = useStyles();
  const [emailError, setEmailError] = useState<string>('');

  const handleChange = (event: React.FocusEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event;

    if (value === '') {
      setEmailError('');
      return;
    }

    if (!RegExp(REGEX_EMAIL).test(value)) {
      setEmailError('Email Invalid');
      return;
    }

    setEmailError('');
    updateEmail(value);
    return;
  };

  return (
    <Grid container className={classes.space}>
      <Grid item xs={12}>
        <TextField
          label="Email"
          noMinHeight
          onBlur={handleChange}
          onFocus={handleChange}
          error={emailError !== ''}
          errorText={emailError}
          size="small"
          data-testid="emailIdField"
        />
      </Grid>
    </Grid>
  );
};

export default SignUpFlowEmail;
